import React, { useRef } from 'react'
import { Button, DialogContent, Grid, Typography } from '@material-ui/core'
import DialogAster from 'asterX-UIkit/Dialog/DialogAster'
import DialogTitleCustom from 'asterX-UIkit/Dialog/DialogTitleCustom'

import { MiscService } from 'lib/api'
import { useSnackbar } from 'notistack'
import { useResErrors } from 'hooks'
import { IN_PROGRESS_STATUS } from 'constants/statuses'
import { useHomeStore } from 'context/HomeStore'
import moment from 'moment'

const RenewModal = ({ requestList, open, onClose }) => {
  const { standardCheck } = useResErrors()
  const { enqueueSnackbar } = useSnackbar()
  const modalRef = useRef(null)

  const {
    homeStore: { chat }
  } = useHomeStore()

  const handleClose = () => {
    onClose()
  }

  const handleRenew = async () => {
    const data = {
      id: requestList?.id,
      status: IN_PROGRESS_STATUS,
      module: requestList?.module,
      type: requestList?.type,
      inProcessDate: moment().format(),
      adminUsername: requestList?.adminUsername,
      adminFullname: requestList?.adminFullname,
      department: requestList?.department,
      chat: JSON.stringify([...chat])
    }
    await MiscService.updateSupportById(data).then(res =>
      standardCheck(res, ({ data }) => {
        enqueueSnackbar('Отправлено', {
          variant: 'success'
        })
        handleClose()
        window.location.reload()
      })
    )
  }

  return (
    <DialogAster id="modal" onClose={handleClose} open={open}>
      <DialogTitleCustom onClose={handleClose}>
        <Typography style={{ fontSize: 18, fontWeight: 600 }}>
          Возобновить заявку
        </Typography>
        <Grid item container xs={12} md={12}>
          <Typography>Вы уверены что хотите возобновить заявку?</Typography>
        </Grid>
      </DialogTitleCustom>
      <DialogContent ref={modalRef}>
        <Grid item container xs={12} spacing={2} style={{ marginTop: 32 }}>
          <Grid item xs={6} md={6}>
            <Button
              fullWidth
              variant="outlined"
              color={'primary'}
              onClick={handleClose}
            >
              {'Отмена'}
            </Button>
          </Grid>
          <Grid item xs={6} md={6}>
            <Button
              fullWidth
              variant="contained"
              color={'primary'}
              onClick={handleRenew}
            >
              {'Подтвердить'}
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </DialogAster>
  )
}
export default RenewModal
